<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<blockquote><p class="left"><a id="pvii"></a> I’m as nauseous as I’ve ever been. I have a terrible headache. My head is pounding. I feel like throwing up and I’m having trouble swallowing. And the beauty of it is, you want to feel like this every day.</p></blockquote><blockquote><p class="center">—T<span style="font-size: smaller">ONY</span> L<span style="font-size: smaller">A</span> R<span style="font-size: smaller">USSA</span></p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?72ae838e